import { OrganizationSuggestItem } from '@shared/model/organization';

export const getOrganizationByInn = ({
    inn,
    organizations,
}: {
    inn: string;
    organizations: OrganizationSuggestItem[];
}) => {
    return organizations.find((organization) => String(organization.inn) === String(inn));
};
